const hcAction = action => `HEALTHCARE/${action}`;

// Spaces
const GET_SPACES = hcAction('GET_SPACES');
const GET_SPACES_SUCCESS = hcAction('GET_SPACES_SUCCESS');
const GET_SPACES_FAILURE = hcAction('GET_SPACES_FAILURE');

const CREATE_SPACE = hcAction('CREATE_SPACE');
const CREATE_SPACE_SUCCESS = hcAction('CREATE_SPACE_SUCCESS');
const CREATE_SPACE_FAILURE = hcAction('CREATE_SPACE_FAILURE');

const UPDATE_SPACE = hcAction('UPDATE_SPACE');
const UPDATE_SPACE_SUCCESS = hcAction('UPDATE_SPACE_SUCCESS');
const UPDATE_SPACE_FAILURE = hcAction('UPDATE_SPACE_FAILURE');

const DELETE_SPACE = hcAction('DELETE_SPACE');
const DELETE_SPACE_SUCCESS = hcAction('DELETE_SPACE_SUCCESS');
const DELETE_SPACE_FAILURE = hcAction('DELETE_SPACE_FAILURE');

// Assessment (client-side compute + save)
const RUN_ASSESSMENT = hcAction('RUN_ASSESSMENT');
const RUN_ASSESSMENT_SUCCESS = hcAction('RUN_ASSESSMENT_SUCCESS');
const SAVE_ASSESSMENT = hcAction('SAVE_ASSESSMENT');
const SAVE_ASSESSMENT_SUCCESS = hcAction('SAVE_ASSESSMENT_SUCCESS');
const SAVE_ASSESSMENT_FAILURE = hcAction('SAVE_ASSESSMENT_FAILURE');

const GET_ASSESSMENTS = hcAction('GET_ASSESSMENTS');
const GET_ASSESSMENTS_SUCCESS = hcAction('GET_ASSESSMENTS_SUCCESS');
const GET_ASSESSMENTS_FAILURE = hcAction('GET_ASSESSMENTS_FAILURE');

// HDPS features (Healthcare Design Points System)
const GET_HDPS_FEATURES = hcAction('GET_HDPS_FEATURES');
const GET_HDPS_FEATURES_SUCCESS = hcAction('GET_HDPS_FEATURES_SUCCESS');
const GET_HDPS_FEATURES_FAILURE = hcAction('GET_HDPS_FEATURES_FAILURE');

const UPDATE_HDPS_FEATURES = hcAction('UPDATE_HDPS_FEATURES');
const UPDATE_HDPS_FEATURES_SUCCESS = hcAction('UPDATE_HDPS_FEATURES_SUCCESS');
const UPDATE_HDPS_FEATURES_FAILURE = hcAction('UPDATE_HDPS_FEATURES_FAILURE');

// Population (staff + patients)
const GET_POPULATION = hcAction('GET_POPULATION');
const GET_POPULATION_SUCCESS = hcAction('GET_POPULATION_SUCCESS');
const GET_POPULATION_FAILURE = hcAction('GET_POPULATION_FAILURE');

const SAVE_POPULATION = hcAction('SAVE_POPULATION');
const SAVE_POPULATION_SUCCESS = hcAction('SAVE_POPULATION_SUCCESS');
const SAVE_POPULATION_FAILURE = hcAction('SAVE_POPULATION_FAILURE');

const DELETE_POPULATION = hcAction('DELETE_POPULATION');
const DELETE_POPULATION_SUCCESS = hcAction('DELETE_POPULATION_SUCCESS');
const DELETE_POPULATION_FAILURE = hcAction('DELETE_POPULATION_FAILURE');

// Financial ROI (client-side compute)
const COMPUTE_STAFF_ROI = hcAction('COMPUTE_STAFF_ROI');
const COMPUTE_PATIENT_ROI = hcAction('COMPUTE_PATIENT_ROI');
const SET_STAFF_ROI = hcAction('SET_STAFF_ROI');
const SET_PATIENT_ROI = hcAction('SET_PATIENT_ROI');

export default {
  GET_SPACES, GET_SPACES_SUCCESS, GET_SPACES_FAILURE,
  CREATE_SPACE, CREATE_SPACE_SUCCESS, CREATE_SPACE_FAILURE,
  UPDATE_SPACE, UPDATE_SPACE_SUCCESS, UPDATE_SPACE_FAILURE,
  DELETE_SPACE, DELETE_SPACE_SUCCESS, DELETE_SPACE_FAILURE,
  RUN_ASSESSMENT, RUN_ASSESSMENT_SUCCESS,
  SAVE_ASSESSMENT, SAVE_ASSESSMENT_SUCCESS, SAVE_ASSESSMENT_FAILURE,
  GET_ASSESSMENTS, GET_ASSESSMENTS_SUCCESS, GET_ASSESSMENTS_FAILURE,
  GET_HDPS_FEATURES, GET_HDPS_FEATURES_SUCCESS, GET_HDPS_FEATURES_FAILURE,
  UPDATE_HDPS_FEATURES, UPDATE_HDPS_FEATURES_SUCCESS, UPDATE_HDPS_FEATURES_FAILURE,
  GET_POPULATION, GET_POPULATION_SUCCESS, GET_POPULATION_FAILURE,
  SAVE_POPULATION, SAVE_POPULATION_SUCCESS, SAVE_POPULATION_FAILURE,
  DELETE_POPULATION, DELETE_POPULATION_SUCCESS, DELETE_POPULATION_FAILURE,
  COMPUTE_STAFF_ROI, COMPUTE_PATIENT_ROI, SET_STAFF_ROI, SET_PATIENT_ROI,
};
